import React, { useState } from "react";
import { Card } from "antd";
import { Megaphone } from "lucide-react";
// import { ANNOUNCEMENTS } from "./announcements";
import { ANNOUNCEMENTS } from "../../variables/announcements";
import AnnouncementCard from "../../components/AnnouncementCard";
import AnnouncementWidget from "../../components/AnnouncementWidget";

const ImportantAnnouncementBoard = () => {
  const [list, setList] = useState(ANNOUNCEMENTS);
  const [selectedId, setSelectedId] = useState(0);
  const selectedAnnouncement = list[selectedId];

  const handleRemove = (id) => {
    setList(prev => prev.filter((_, index) => index !== id));

    setSelectedId(prev => {
      if (prev === id) return 0;
      if (prev > id) return prev - 1;
      return prev;
    });
  };

  if (list.length === 0) return null;

  return (
    <Card
      className="flex flex-col gap-6 rounded-xl bg-gradient-to-br from-violet-50 via-white to-purple-50 overflow-hidden dark:from-violet-900 dark:via-intsamis-900 dark:to-purple-900"
    >
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-violet-500/10 to-purple-500/10 rounded-full blur-3xl -z-0"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-blue-500/10 to-cyan-500/10 rounded-full blur-3xl -z-0"></div>

      <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 relative z-10">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-xl bg-gradient-to-br from-violet-500 to-purple-600 shadow-lg shadow-violet-500/30">
              <Megaphone className="w-6 h-6 text-white" />
            </div>
            <div>
              <h4 className="text-[20px] text-violet-600 dark:text-violet-100">
                Important Announcements
              </h4>
              <p className="muted-text">
                Stay informed with the latest updates
              </p>
            </div>
          </div>

          <div className="status-indicator text-xs bg-gradient-to-r from-violet-600 to-purple-600 text-white border-0 shadow-lg">
            {list.length} Active
          </div>
        </div>
      </div>

      <div className="p-6 relative z-10 space-y-4">
        {list
            .filter((_, index) => index === selectedId)
            .map((announcement, index) => (
          <AnnouncementCard
            key={index}
            announcement={announcement}
            isSelected={true}
            onRemove={handleRemove}
            selectedId={selectedId}
          />
        ))}
        <div className="flex items-center justify-between mb-2">
          <h4 className="text-xs font-semibold muted-text">
            All Announcements
          </h4>

          <div className="flex items-center gap-1">
            {list.map((_, index) => (
              <button
                key={index}
                onClick={() => setSelectedId(index)}
                className={`rounded-full transition-all duration-300 ${
                  index === selectedId
                    ? "w-4 h-1.5 bg-violet-600"
                    : "w-1.5 h-1.5 bg-slate-300 hover:bg-slate-400"
                }`}
              ></button>
            ))}
          </div>
        </div>

        <AnnouncementWidget
          announcements={list}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          onRemove={handleRemove}
          selectedAnnouncement={selectedAnnouncement}
        />
      </div>
    </Card>
  );
};

export default ImportantAnnouncementBoard;
